import { DEFAULT_DECK_ID } from "@app/protocol";
/** Every deck picture is cut at 360x504 from a 750x1050 master. */
export const CARD_ASPECT = 750 / 1050;
/** The picture's own corner, 24 px on 750x1050, as a CSS radius (`horizontal / vertical`). */
export const CARD_RADIUS = "3.2% / 2.29%";
export const DECKS = {
    classic: {
        id: "classic",
        dir: "/decks/classic",
        preview: "/decks/classic-preview.webp",
    },
    anime: { id: "anime", dir: "/decks/anime", preview: "/decks/anime-preview.webp", fresh: true },
    obsidian: {
        id: "obsidian",
        dir: "/decks/obsidian",
        preview: "/decks/obsidian-preview.webp",
        fresh: true,
    },
};
/** Classic is free and the default (ADR 0024, 0029). */
export const DEFAULT_DECK = DECKS[DEFAULT_DECK_ID];
/** The deck for an id; one this client does not know yet falls back to Classic (review 0015 U8). */
export function deckOf(id) {
    return DECKS[id ?? ""] ?? DEFAULT_DECK;
}
const RANK_FILE = { 11: "j", 12: "q", 13: "k", 14: "a" };
export function cardImage(card, deck = DEFAULT_DECK) {
    return `${deck.dir}/${card.suit}-${RANK_FILE[card.rank] ?? card.rank}.webp`;
}
export function backImage(deck = DEFAULT_DECK) {
    return `${deck.dir}/back.webp`;
}
const SUITS = ["spades", "hearts", "diamonds", "clubs"];
/** All 53 pictures of a deck, to fetch before the first deal. */
export function deckImages(deck = DEFAULT_DECK) {
    const faces = SUITS.flatMap((suit) => Array.from({ length: 13 }, (_, i) => cardImage({ suit, rank: i + 2 }, deck)));
    return [backImage(deck), ...faces];
}
//# sourceMappingURL=decks.js.map